import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "total"]

  add(e) {
    e.preventDefault()
    const id = e.currentTarget.dataset.id

    fetch("/cart/add", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ variation_id: id })
    }).then(() => window.location.reload())
  }

  remove(e) {
    e.preventDefault()
    const id = e.currentTarget.dataset.id

    fetch("/cart/remove", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ variation_id: id })
    }).then(() => window.location.reload())
  }
}
